import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as StatCardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/StatCardBlock/StatCardBlockDefaultData";
import {
  createH3Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getColorOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { getHomepageBlockPrimaryStyleOptions } from "../constants";

const stats = [
  {
    number: "94%",
    text: "Client satisfaction rate",
  },
  {
    number: "150+",
    text: "Executive coaches",
  },
  {
    number: "12+",
    text: "Years of experience",
  },
] as const;

const createStatCardBlock = ({
  number,
  text,
  baseData = StatCardDefaultData,
}: {
  number: string;
  text: string;
  baseData?: BaseBlock;
}): BaseBlock => ({
  ...baseData,
  id: uuidv4(),
  props: {
    ...baseData.props,
    content: {
      ...baseData.props.content,
      type: "children",
      prop: "children",
      value: [
        createH3Block({
          text: number,
          styles: {
            color: getColorOptions("var(--theme-website-color-text-secondary)"),
          },
        }),
        createPBlock({
          text,
        }),
      ],
    },
  },
});

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock5_2",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: stats.map(stat => createStatCardBlock(stat)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getHomepageBlockPrimaryStyleOptions(),
      },
    },
  },
};
